import { Link as LinkBase } from 'react-router-dom';
import styled, { css } from 'styled-components';

const HEADER_MARGIN_BOTTOM = 20;

export const TopBarWrapper = styled.div`
  position: relative;
  margin-bottom: 20px;
`;

export const Chips = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 10px 12px;
`;

export const Chip = styled(LinkBase)<{ $isActive: boolean }>(
  ({ $isActive, theme: { palette, typography } }) => css`
    display: inline-flex;
    align-items: center;
    padding: 6px 12px;
    border-radius: 4px;
    font-family: ${typography.fontFamily};
    font-size: 16px;
    font-weight: ${$isActive ? 700 : 500};
    text-decoration: none;
    white-space: nowrap;
    color: ${$isActive ? palette.common.white : palette.common.black};
    background-color: ${$isActive ? palette.grey[900] : palette.grey[300]};
  `,
);

export const HeaderActions = styled.div<{ $headerHeight: number }>(
  ({ $headerHeight }) => css`
    position: absolute;
    right: 0;
    bottom: calc(100% + ${HEADER_MARGIN_BOTTOM}px);
    height: ${$headerHeight}px;
    display: flex;
    align-items: center;
    gap: 16px;
  `,
);
